module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-tabs"
  }, _vm._l((_vm.tabItems), function(item) {
    return _c('div', {
      staticClass: "c-tabs-item",
      class: item.select ? 'c-tabs-item-select' : '',
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          _vm.itemClick(item)
        }
      }
    }, [_vm._v("\n    " + _vm._s(item.name) + "\n  ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-797ef64c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-tab/index.vue
// module id = 1064
// module chunks = 2